<template>
    <DCard
        padding
    >
        <Form
            :currency-rates-api-settings="currencyRatesApiSettings"
            :errors="errors"
            @form-submitted="submitData"
        />
    </DCard>
</template>

<script>
import Form from '~@/Components/Settings/CurrencyRatesApiSettings/Form'

export default {
    name: 'CurrencyRatesApiSettingsCreate',
    components: {
        Form
    },
    props: {
        currencyRatesApiSettings: {
            type: Object,
            default () {
                return {}
            }
        },
        errors: {
            type: Object,
            default () {
                return {}
            }
        }
    },
    methods: {
        submitData (form) {
            form.post(this.$route('settings.currency-rates-api-settings.store'))
        }
    }
}
</script>
